import React, {useEffect, useState} from 'react';
import {t} from 'react-switch-lang';
import ListNav from '../../../../components/tabsNav/TabsNav';
import Dropdown from '../../../../components/droppdown/dropdown';
import {Link, useHistory, useLocation, useParams} from 'react-router-dom';
import BackBtn from '../../../RiskComponents/pageHeader/img/arrow-left.svg';
import './RevisionDetail.scss';
import EditRevisionForm from '../revisionsForm/EditRevisionForm';
import {deleteRevisions, getRevision} from '../../../../services/revisions';
import Prompt from '../../../../components/prompt/prompt';
import Toast from '../../../../components/toast/Toast';
import Swal from 'sweetalert2';
import PreventTransitionPrompt from '../../../../components/preventTransitionprompt/PreventTransition';
import TransitionModal from '../../../../components/preventTransitionprompt/TransitionModal';
import roles from '../../../../utils/roles';
import {useUserContext} from '../../../../contexts/UserContext';

const RevisionDetail = () => {
  const [activeTab, setActiveTab] = useState('revision-detail');
  const [editIsDisabled, setEditIsDisabled] = useState(true);
  const [transitionModal, setTransitionModal] = useState(false);
  const [tempTab, setTempTab] = useState('');
  const [allowCRUD, setAllowCRUD] = useState(false);
  const [revisionData, setRevisionData] = useState();
  const {state} = useLocation();
  const history = useHistory();
  const user = useUserContext();

  const params = useParams();

  const fetch = async () => {
    const response = await getRevision(params?.id);
    setRevisionData(response);
  };

  useEffect(() => {
    fetch();
  }, [params.id, editIsDisabled]);

  useEffect(() => {
    if (state?.isEditing) {
      setEditIsDisabled(false);
    }
  }, [state]);

  const revisionRoles = [
    roles.role_admin,
    roles.role_super_admin,
    roles.role_internal_auditor,
    roles.role_head_of_internal_audit,
  ];

  useEffect(() => {
    const result = revisionRoles.filter((element) =>
      user?.authorities?.includes(element)
    );
    setAllowCRUD(result.length > 0);
  }, [user]);

  return (
    <div>
      <TransitionModal
        open={transitionModal}
        toggleModal={() => setTransitionModal(!transitionModal)}
        onCancel={() => setTransitionModal(false)}
        onOk={() => {
          setEditIsDisabled(true);
          setTransitionModal(false);
          setActiveTab(tempTab);
        }}
      />
      <PreventTransitionPrompt when={!editIsDisabled} />
      <div className="container-fluid controls d-flex align-items-center justify-content-end">
        <Link
          to={window.location.pathname}
          className="return-btn-revisions d-flex "
          onClick={() => history.go(-1)}
        >
          <img src={BackBtn} alt="icon" />
          <span>
            {t('common.revision')}:{revisionData?.data?.referenceNumber}
          </span>
        </Link>
        <div className="row">
          <div className="col-12 d-flex justify-content-end">
            {editIsDisabled && allowCRUD ? (
              <div>
                <button
                  className="primary-btn mr-3 cursor-pointer"
                  onClick={(event) => {
                    event.preventDefault();
                    setEditIsDisabled(false);
                    setActiveTab('revision-detail');
                  }}
                >
                  {t('common.edit')}
                </button>
              </div>
            ) : null}
            {editIsDisabled && allowCRUD && (
              <Dropdown
                buttonClass="options-btn"
                trigger={
                  <img src={process.env.PUBLIC_URL + '/images/dots.svg'} />
                }
                children={
                  <>
                    <li
                      onClick={async () => {
                        await Prompt.fire({
                          title: t('title.deleteRevision'),
                          text: t('question.deleteRevision'),
                          confirmButtonText: t('common.confirm'),
                          cancelButtonText: t('common.cancel'),
                          preConfirm: async () => {
                            try {
                              const response = await deleteRevisions(
                                params?.id
                              );
                              if (response.status === 204) {
                                Toast.fire({
                                  title: t('message.deleteSuccess3', {
                                    entity: t('common.revision'),
                                  }),
                                  icon: 'success',
                                });
                                setTimeout(() => {
                                  history.go(-1);
                                }, 1000);
                              } else {
                                Swal.fire({
                                  text: t('Pages.messages.deleteError'),
                                  icon: 'error',
                                });
                              }
                            } catch (err) {
                              if (
                                err.response?.data?.code ===
                                'revision-could-not-be-deleted'
                              ) {
                                Swal.fire({
                                  text: t('revisions.hasFindingsDeleteError'),
                                  icon: 'error',
                                });
                              } else {
                                Swal.fire({
                                  text: t('Pages.messages.deleteError', {
                                    entity: t('common.revision'),
                                  }),
                                  icon: 'error',
                                });
                              }
                            }
                          },
                        });
                      }}
                    >
                      {t('common.delete')}
                    </li>
                  </>
                }
              ></Dropdown>
            )}
          </div>
        </div>
      </div>
      <ListNav
        items={[
          {name: t('sidebar.RevisionDetail'), target: 'revision-detail'},
          // {name: t('sidebar.revisionTrail'), target: 'revision-trail'},
        ]}
        textProperty="name"
        itemValue="target"
        selectedItem={activeTab}
        onItemSelect={(e) => {
          if (!editIsDisabled && e !== 'revision-detail') {
            setTransitionModal(true);
            setTempTab(e);
          } else {
            setActiveTab(e);
          }
        }}
        classes="tabs-nav  pl-0"
      />

      <div className={'revisions-tabs-content'}>
        {activeTab === 'revision-detail' && (
          <>
            <EditRevisionForm
              editIsDisabled={editIsDisabled}
              setEditIsDisabled={setEditIsDisabled}
              data={revisionData}
            />
          </>
        )}
        {/*{activeTab === 'revision-trail' && <>Revizorski trag</>}*/}

        <div className={'revisions-detail-footer'}>
          <button
            className="primary-btn mr-3 cursor-pointer"
            onClick={(event) => {
              event.preventDefault();
              history.push({
                pathname: `/revisions/${params?.id}/findings`,
              });
            }}
          >
            {t('revisions.findingsList')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RevisionDetail;
